// extracted by mini-css-extract-plugin
export default {"container":"Icon_container__n+fB3"};